export default __webpack_public_path__ + "static/media/cat-highscores-table.62ef5168.png";